// Unpublished Work © 2021-2024 Deere & Company.

import {BusinessActivities} from '../../state/struct/configuration/business-activities';

export const adaptBusinessActivities = (configuration) => {
    const trueFlags = Object.keys(BusinessActivities({})).reduce((accumulator, key) => ({
        ...accumulator,
        [key]: true
    }), {});

    return {
        ...configuration,
        businessActivities: {
            ...trueFlags,
            ...configuration.businessActivities
        }
    };
};
